// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const InfoOutline = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 96 96" {...props}>
		<path
			d="M48.5 13C28.925 13 13 28.925 13 48.5S28.925 84 48.5 84 84 68.075 84 48.5 68.075 13 48.5 13m0 75C26.72 88 9 70.28 9 48.5S26.72 9 48.5 9 88 26.72 88 48.5 70.28 88 48.5 88Zm0-48a3 3 0 0 0-3 3v24a3 3 0 0 0 6 0V43a3 3 0 0 0-3-3Zm0-14a4 4 0 1 0 0 8 4 4 0 0 0 0-8Z"
			fillRule="evenodd"
		/>
	</svg>
);
export default InfoOutline;
